import { CommonModule } from "@angular/common";
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";

export type Type = 'button' | 'submit';
export type Fill = 'solid' | 'outline' | 'clear';
export type Color = 'primary' | 'secondary' | 'tertiary' | 'success' | 'warning' | 'danger' | 'light' | 'medium' | 'dark';

export type ButtonInput = {
  type: Type;
  fill: Fill;
  action: string;
  label?: string;
  color?: Color;
  prefix?: string;
  suffix?: string;
  disabled?: boolean;
  ariaLabel?: string;
}

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule
  ]
})
export class ButtonComponent {
  private __type: Type = 'button';
  private __fill: Fill = 'solid';
  private __color: Color = 'primary';
  private __form: string = '';

  @Input('form')
  get _form(): string { return this.__form; }
  set _form(val: string | undefined) { this.__form = val || ''; }

  @Input('type')
  get _type(): Type { return this.__type; }
  set _type(val: Type | undefined) { this.__type = val || 'button'; }

  @Input('fill')
  get _fill(): Fill { return this.__fill; }
  set _fill(val: Fill | undefined) { this.__fill = val || 'solid'; }

  @Input('color')
  get _color(): Color { return this.__color; }
  set _color(val: Color | undefined) { this.__color = val || 'primary'; }
  @Input('prefix') _prefix: string | undefined;
  @Input('suffix') _suffix: string | undefined;
  @Input('disabled') _disabled: boolean = false;
  @Input('ariaLabel') ariaLabel?: string;

  @Output('handleClick') eventEmitterHandleClick = new EventEmitter<Event>();

  constructor() { }

  handleClick(event: Event) {
    this.eventEmitterHandleClick.emit(event);
  }
}
